export default (text, type) => {
  if (!text && text !== 0) return '--';
  const hour = parseInt(text / 60 / 60, 10);
  const min = parseInt(text / 60, 10);
  const sec = parseInt(text % 60, 10);

  if (type === 'hour') {
    return `${hour}:${min >= 10 ? min : `0${min}`}:${
      sec >= 10 ? sec : `0${sec}`
    }`;
  }

  return `${min >= 10 ? min : `0${min}`}:${sec >= 10 ? sec : `0${sec}`}`;
};
